<!--hlsPlayer  -->
<template>
  <div class="cam" style="text-align: center;width:100%;height: 100%">
    <div v-show="isPlay"
      :style="`background-image: url(${poster}); background-size: cover; width: 100%; height: 100%;`">
    </div>
    <div class="video" v-show="!isPlay" ref="camDOMidRef" :id="`player-${camDOMid}`"></div>
  </div>
</template>

<script>
import PmStreaming from "../streaming/src";
import FlvPlayer from "xgplayer-flv";
import HlsPlugin from "xgplayer-hls";
export default {
  components: {},
  props: {
    camDOMid: { type: String },
    width: { type: String },
    height: { type: String },
    videoUrl: { type: String },
    controls: {
      type: Boolean,
      default: true
    },
    limitReloadCount: {
      type: Number,
      default: 10,
    },
    poster: {
      type: String,
      default: require('@/assets/images/video_empty.jpg')
    },
    voice: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: '1'
    },
    serverUrl: {
      type: String,
      default: ''
    },
    keyIframeOffset: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      isPlay: false, //是否显示播放画面
      videoPlayerDom: null,
      player: null, //播放实例
      videoHeight: 750,
      videoWidth: document.documentElement.clientWidth - 302,
      currentTime: 0, //当前时间
    }
  },
  watch: {
    //监听videoUrl变化，改变播放地址
    videoUrl: {
      handler(newVal) {
        this.reloadPlayer(newVal);
      }
    }
  },

  mounted() {
    //获取数据，连接
    this.initPlayer(this.videoUrl);
  },
  methods: {
    reloadPlayer(url) {
      if (this.player) {
        this.videoPlayerDom.destroy();
        this.videoPlayerDom = null;
        this.player = null;
      }
      this.initPlayer(url);
    },
    setCurrentTime(timeDeviationSec) {
      if (this.keyIframeOffset && (this.keyIframeOffset.indexOf(timeDeviationSec) > -1)) {
        this.player.currentTime = timeDeviationSec;
        // this.isPlay = false
      } else {
        this.$message({
          type: 'error',
          message: '无效关键帧，无法定位。'
        })
      }
    },
    // 设置视频配置(注意：initPlayer应放在异步函数里或mounted之后，不可在created里直接加载，否则不生效)
    initPlayer(url) {
      let videoUrl = url;
      this.isPlay = true;

      let plugins = [];
      if (videoUrl?.indexOf('.flv') != -1) {
        plugins = [FlvPlayer]
      } else {
        plugins = [HlsPlugin]
      }

      this.videoPlayerDom = new PmStreaming({
        el: document.getElementById(`player-${this.camDOMid}`),
        url: videoUrl,
        autoplay: true,
        autoplayMuted: false, //自动播放静音，设置自动播放参数必要参数
        volume: 1,
        poster: this.poster,
        height: '100%',
        width: '100%',
        plugins,
        screenShot: {
          disable: false
        },
      });

      this.videoPlayerDom.player.on('screenShot', (url) => {
        var blob = new Blob([url], {
          type: 'image/png'
        });

        const formData = new FormData();
        formData.append('file', blob);
        if (blob) {
          this.$http.post('/bigfileUpload/uploadFile', formData).then(res => {
            if (res.data.code == "1") {
              var filePath = res.data.data;
              this.$emit('cutAndUploadSuccess', filePath);
            } else {
              this.$message({ message: "上传失败", type: "error" });
            }
          })
        }
      })

      this.player = this.videoPlayerDom.player;
      this.isPlay = false;
    },
    play() { //播放
      if (this.player) {
        this.player.play();
      }
    },
    pause() { // 暂停
      if (this.player) {
        this.player.pause();
      }
    },
  },
  beforeDestroy() {
    if (this.videoPlayerDom) {
      this.videoPlayerDom.destroy();
      this.videoPlayerDom = null;
      this.player = null;
    }
  },
  destroyed() {
    if (this.videoPlayerDom) {
      this.videoPlayerDom.destroy();
      this.videoPlayerDom = null;
      this.player = null;
    }
  },

}

</script>
<style lang='less' scoped></style>
<style lang='less'>
.video {
  width: 100% !important;
  height: 100%;
}
</style>
